import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { FormControlLabel, Radio, Tooltip } from '@mui/material'

function WithGroupsOption({ disabled, tooltip }: { disabled?: boolean; tooltip?: ReactNode }) {
  return (
    <Tooltip title={disabled && tooltip}>
      <FormControlLabel
        value="groups"
        control={<Radio disabled={disabled} color="primary" />}
        label={<FormattedMessage id={'common.shareDialog.sharingMode.groups'} />}
      />
    </Tooltip>
  )
}

export default WithGroupsOption
